import { PolishPlurals } from '@/assets/locales/PolishPlurals.model.ts';
import { ValidationTranslation } from '@/assets/locales/validation/validation.translation.en.ts';

export const validationTranslation: PolishPlurals<ValidationTranslation> = {
  answersCorrect: 'Zaznacz co najmniej jedną poprawną odpowiedź.',
  answersMin: 'Dodaj co najmniej dwie odpowiedzi.',
  answersSingleCorrect: 'Zaznacz dokładnie jedną poprawną odpowiedź.',
  categoryNameTaken: 'Kategoria o tej nazwie już istnieje. Wielkość liter nie ma znaczenia.',
  categoryPrefixTaken: 'Inna kategoria ma już ten prefiks. Wielkość liter nie ma znaczenia.',
  email: 'Wpisz poprawny adres e-mail.',
  expectedAnswersMax: 'Dodaj najwyżej {{max}} oczekiwanych odpowiedzi.',
  expectedAnswersMin: 'Dodaj co najmniej jedną oczekiwaną odpowiedź.',
  expectedAnswersUnique:
    'Każda oczekiwana odpowiedź może wystąpić tylko raz. Wielkość liter i spacje nie mają znaczenia.',
  integer: 'Wpisz liczbę całkowitą.',
  maxDecimalPlaces_few: 'Wpisz liczbę z najwyżej {{count}} miejscami po przecinku.',
  maxDecimalPlaces_many: 'Wpisz liczbę z najwyżej {{count}} miejscami po przecinku.',
  maxDecimalPlaces_one: 'Wpisz liczbę z najwyżej {{count}} miejscem po przecinku.',
  maxLength: 'Wpisz najwyżej {{max}} znaków.',
  maxNumber: 'Wpisz liczbę nie większą niż {{max}}.',
  minLength: 'Wpisz co najmniej {{min}} znaków.',
  number: 'Wpisz liczbę.',
  numberRange: 'Wpisz liczbę całkowitą od {{min}} do {{max}}.',
  positionScopeRequired: 'Wybierz, dla kogo jest pytanie: dla wszystkich stanowisk albo wybranych.',
  positionsMin: 'Wybierz co najmniej jedno stanowisko.',
  positiveNumber: 'Wpisz liczbę większą od zera.',
  required: 'To pole jest wymagane.',
  sapNumber: 'Wpisz numer SAP, używając samych cyfr.',
  sourceLinkRepeated: 'Ta procedura ma już ten link.',
  sourceLinksMax: 'Dodaj najwyżej {{max}} linków do jednej procedury.',
  sourceLinkUrl: 'Wpisz pełny adres zaczynający się od http:// lub https://.',
  sourceRepeated: 'Pytanie ma już to źródło.',
  sourcesMax: 'Dodaj najwyżej {{max}} źródeł.',
  sourceTypeRequired: 'Wybierz typ źródła.',
  surveyQuestionsMax: 'Ankieta może mieć najwyżej {{max}} pytań.',
  surveyQuestionType:
    'Do ankiety pasują tylko pytania jednokrotnego wyboru i otwarte. Usuń pozostałe.',
  tagTaken: 'Taki tag już istnieje. Wielkość liter i spacje nie mają znaczenia.',
  testAttemptLimitRepeated: 'To stanowisko ma już wyjątek.',
  testCategoryRepeated: 'Ta kategoria jest już w innej części testu.',
  testExaminerQuestions:
    'Pytania oceniane przez egzaminatora pasują tylko do egzaminu praktycznego. Usuń je albo zmień cel testu.',
  testPartsMax: 'Dodaj najwyżej {{max}} części.',
  testPurposeRequired: 'Wybierz, do czego służy test.',
  testQuestionsMax: 'Wybierz najwyżej {{max}} pytań.',
  testQuestionsMin: 'Wybierz co najmniej jedno pytanie.',
  topicsMax: 'Dodaj najwyżej {{max}} zagadnień.',
  topicsMin: 'Dodaj co najmniej jedno zagadnienie.',
  topicsToPickMax:
    'Egzaminator nie może wybrać więcej zagadnień, niż jest na liście. Dodaj zagadnienia albo zmniejsz tę liczbę.',
  topicsUnique:
    'Każde zagadnienie może wystąpić tylko raz. Wielkość liter i spacje nie mają znaczenia.',
};
